import { type NamedValue, useI18n } from 'petite-vue-i18n'

import { locale, type MessageSchema } from '@/plugins/i18n'
import { UILanguage } from '@/types'

/**
 * Wrapper um i18n für richtige Type-Checks:
 * - Input ist ein TranslationKey, der in translation/de.json vorkommt (also ein Text der auch wirklich eine Übersetzung hat)
 * - Output ist ein String, weil wir die tieferen Features von i18n nie benutzen und es deshalb kein TranslateResult sein kann.
 */
export default function useAsiXI18n() {
  const { t: i18nT } = useI18n<MessageSchema, UILanguage>()

  function t(key: TranslationKey): string
  function t(key: TranslationKey, plural: boolean): string
  function t(key: TranslationKey, values: unknown[] | NamedValue, plural?: boolean): string
  function t(
    key: TranslationKey,
    valuesOderPlural?: unknown[] | NamedValue | boolean,
    plural = false
  ): string {
    if (typeof valuesOderPlural === 'boolean') {
      return i18nT(key, valuesOderPlural ? 2 : 1)
    }
    if (Array.isArray(valuesOderPlural)) {
      return plural
        ? i18nT(key, valuesOderPlural, { plural: 2 })
        : i18nT(key, valuesOderPlural)
    }
    if (valuesOderPlural !== undefined) {
      return plural
        ? i18nT(key, valuesOderPlural, { plural: 2 })
        : i18nT(key, valuesOderPlural)
    }

    return i18nT(key)
  }

  return { t, locale }
}
export type AsiXTranslateT = ReturnType<typeof useAsiXI18n>['t']
